import { Grid } from "@mui/material";
import { useState } from "react";
import AddPageWrapper from "../../components/general/AddPageWrapper";
import TitleBar from "../../components/general/TitleBar";
import Answer from "./Answer";

const answersContainerStyle = { margin: "10px 30px 30px 30px", gap: 10 };

export default function AnswerKey({ task, setTask, isReadOnly }) {
  const [expand, setExpand] = useState(true);
  const { task_answers } = task;

  return (
    <Grid container style={{ marginTop: 20 }}>
      <TitleBar title="Answer Key" state={expand} setState={setExpand} />
      {expand && (
        <AddPageWrapper>
          <Grid container style={answersContainerStyle}>
            {task_answers.map((answer, index) => (
              <Answer
                key={index}
                count={index}
                answer={answer}
                task={task}
                setTask={setTask}
                isReadOnly={isReadOnly}
              />
            ))}
          </Grid>
        </AddPageWrapper>
      )}
    </Grid>
  );
}
